import { useEnsName } from "wagmi";
import { isAddress } from "viem";
import { ContributionHistory } from "./ContributionHistory";
import { useContributionsByDonor } from "../hooks/useContributionsByDonor";
import { ContributionHistoryError } from "./ContributionHistoryError";
import { jsx as _jsx } from "react/jsx-runtime";
export function ContributionHistoryContainer(props) {
  const {
    isLoading,
    isError,
    error,
    data
  } = useContributionsByDonor(props.chainIds, props.address);
  const {
    data: ensName
  } = useEnsName({
    /* If props.address is an ENS name, don't pass in anything, as we already have the ens name*/
    address: isAddress(props.address) ? props.address : undefined,
    chainId: 1
  });
  if (isLoading) {
    return /*#__PURE__*/_jsx("div", {
      children: "Loading..."
    });
  }
  if (isError) {
    console.error("Error", error);
    return /*#__PURE__*/_jsx(ContributionHistoryError, {
      address: props.address,
      ensName: ensName
    });
  }
  return /*#__PURE__*/_jsx(ContributionHistory, {
    contributionsData: data,
    address: props.address,
    ensName: ensName
  });
}